import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AutheticationService } from '../../services/authetication.service';
import { WsService } from '../../services/ws.service';
import { Router } from '@angular/router';
import { DateAdapter } from '@angular/material';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent implements OnInit {
  @Input() sidenav: any;
  @Input() controlMenu: any;
  @Input() titlePage: any;
  @Input() user;
  socketState = false;

  constructor(
    public translate: TranslateService,
    public auth: AutheticationService,
    private ws: WsService,
    private router: Router,
    private adapter: DateAdapter<any>,
    private cookieService: CookieService
  ) {
    this.ws.onOpen.subscribe(data => {
      this.socketState = Boolean(data);
    });
  }

  ngOnInit() {}

  logOut() {
    this.auth.logOut();
    this.ws.close();
    this.router.navigate(['/login']);
  }

  logIn() {
    return !this.auth.isToken();
  }

  setLang(lang) {
    console.log(lang);

    lang === 'ua' ? this.adapter.setLocale('ru-UA') : this.adapter.setLocale(lang);

    this.translate.use(lang);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/toolbar/toolbar.component.ts